import Text from '../../../Text'

import * as styles from './CalendarGridWeekHours.module.css'

function CalendarGridWeekHours({ hours }) {
  return (
    <div className={styles.CalendarGridWeekHours}>
      {hours.map(hour => (
        <Text isSecondary className={styles.hourLabel} key={hour.value}>
          {hour.label}
        </Text>
      ))}
    </div>
  )
}

export default CalendarGridWeekHours
